<template>
    <v-app>
        <registration-app-bar></registration-app-bar>

        <v-content>
            <v-container>
                <div class="text-center">
                    <slot name="center"></slot>
                </div>
                <v-row justify="center">
                    <v-col cols="12" sm="6" lg="5">
                        <slot name="information"></slot>
                    </v-col>

                    <v-col cols="12" sm="6" lg="7">
                        <slot name="registration"></slot>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import RegistrationAppBar from './RegistrationAppBar.vue'

export default {
    components: {
        RegistrationAppBar,
    }
}
</script>
